import { t } from "i18next";
import { DataTableData } from "../../../../../components/deprecated/DataTable/DataTable";
import { DataObjectHelper, DataObjectType } from "../../DataObjects/DataObjectHelper";
import { FirebaseDataBooleanField } from "../../DataObjectField/Generic/FirebaseDataBooleanField";
import { FirebaseDataStringField } from "../../DataObjectField/Generic/FirebaseDataStringField";
import { FirebaseDataNumberField } from "../../DataObjectField/Generic/FirebaseDataNumberField";

export class LandaxIncidentDataHelper extends DataObjectHelper<DataObjectType> {
  id = () => "landax_incident";
  displayName = () => t("main.pushNotifications");

  Id = new FirebaseDataStringField<DataObjectType>("Id", "ID", (data) => (typeof data.Id === "string" ? data.Id : ""));
  Description = new FirebaseDataStringField<DataObjectType>("Description", t("main.description"), (data) =>
    typeof data.description === "string" ? data.description : ""
  );
  IsClosed = new FirebaseDataBooleanField<DataObjectType>("IsClosed", t("main.solved"), (data) =>
    typeof data.IsClosed === "boolean" ? data.IsClosed : false
  );
  CategoryId = new FirebaseDataNumberField<DataObjectType>("CategoryId", t("main.category"), (data) =>
    typeof data.CategoryId === "number" ? data.CategoryId : undefined
  );
  CloseNotes = new FirebaseDataStringField<DataObjectType>("CloseNotes", t("integrations.landax.fields.closeNotes"), (data) =>
    typeof data.CloseNotes === "string" ? data.CloseNotes : ""
  );
  TypeId = new FirebaseDataNumberField<DataObjectType>("TypeId", t("integrations.landax.fields.type"), (data) =>
    typeof data.TypeId === "number" ? data.TypeId : undefined
  );
  LocationId = new FirebaseDataNumberField<DataObjectType>("LocationId", t("integrations.landax.fields.location"), (data) =>
    typeof data.LocationId === "number" ? data.LocationId : undefined
  );

  allFields() {
    return [this.Id, this.Description, this.IsClosed, this.CategoryId, this.CloseNotes, this.TypeId, this.LocationId];
  }
  getAllDataTableDatas(documents: DataObjectType[]): DataTableData[] {
    return [];
  }
}

